import CryptoJS from "crypto-js";
import crypto from 'crypto'

// 加密key值 ，Base64编码
const encryptedKey = 'M0FFQjdFMzkwODRBNzg1MjRCNTdGNzgyMjEzMEU0NEU='

const CryptoJSBase64Decode = (data)=>CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)

/**
 * 解密AES加密的字符串。
 * @param {string} encrypted 加密的字符串。
 * @param {string} iv 初始化向量，Base64编码。
 * @returns {string|undefined} 解密后的字符串，如果解密失败则返回undefined。
 */

const getAesString = (encrypted, iv) => {
  // 输入验证
  if (!encrypted || typeof encrypted !== 'string' || !iv || typeof iv !== 'string') {
    console.error('无效的输入参数');
    return undefined;
  }
  const key = CryptoJS.enc.Base64.parse(encryptedKey);
  const decryptedIv = CryptoJS.enc.Base64.parse(iv);
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: decryptedIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

const getMD5String = (str) => {
  const hash = crypto.createHash('md5')
  hash.update(str)
  return hash.digest('hex')
}

/**
 * 解密数据。如果输入是字符串，则直接解密；如果输入是对象，则递归解密对象的每个属性值。
 * @param {string|Object} data 需要解密的数据，可以是字符串或对象。
 * @param {string} iv 初始化向量，Base64编码。
 * @returns {string|Object} 解密后的数据，可能是字符串或对象。
 */
const decryptData = (data, iv) => {
  // 检查data是否为null或undefined
  if (data == null || data === undefined) {
    throw new Error('输入数据不能为空');
  }
  // 处理字符串类型
  if (typeof data === 'string') {
    return getAesString(data, iv)
  }
  // 处理对象类型
  if (Object.prototype.toString.call(data) === '[object Object]') {
    const decryptedData = {};
    Object.keys(data).forEach((key) => {
      // 确保仅处理对象自有属性
      if (data.hasOwnProperty(key)) {
        try {
          decryptedData[key] = getAesString(data[key],iv); // 递归解密对象属性值
        } catch (error) {
          console.error(`解密属性 '${key}' 时出错: ${error.message}`);
          // 选择是抛出异常还是记录错误并继续，这里选择记录错误并继续
        }
      }
    });
    return decryptedData;
  }

  // 对于不支持的类型，抛出错误
  throw new TypeError('不支持的数据类型');
}


export {
  CryptoJSBase64Decode,
  getAesString,
  getMD5String,
  decryptData
}